export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-9])|([12][0-9])|30|31|32)([0-8][0-9])([0-9]{2})$/));
    }
}
